/* istanbul ignore file */
import { mainApi } from "config";
import { getClientFor } from "infrastructure/http";
import { ILocalizable } from "infrastructure/localization";
import { releaseMessages } from "ui/screens/release/release.localization";

export interface IGetReleasesRequest {
  filterName?: string;
  status?: string;
  createdDate?: string;
  releaseDate?: string;
}

export interface IReleaseMessage {
  messageId: string;
  text: string;
}

export interface IGetReleasesResponseRow {
  name: IReleaseMessage;
  releaseDate?: Date;
  createdDate: Date;
  releaseId: string;
  status: string;
}

const getApiProvider = () => {
  const createReleaseSearchRequest = (request: IGetReleasesRequest) => {
    const params = new URLSearchParams();

    request.filterName && params.append("name", request.filterName);
    request.status && params.append("status", request.status);
    request.createdDate && params.append("createdDate", request.createdDate);
    request.releaseDate && params.append("releaseDate", request.releaseDate);

    return { params };
  };

  return {
    getReleaseStatuses: () => {
      const statuses: ILocalizable[] = [
        { messageId: releaseMessages.option("releaseStatusPlanning") },
        { messageId: releaseMessages.option("releaseStatusFrozen") },
        { messageId: releaseMessages.option("releaseStatusShipped") }
      ];
      return statuses;
    },
    getReleases: async (request: IGetReleasesRequest): Promise<IGetReleasesResponseRow[]> =>
      (await getClientFor(mainApi.name).get<IGetReleasesResponseRow[]>("/releases", createReleaseSearchRequest(request))).data
  };
};

export const releasesManagerApi = getApiProvider();
